import { createFileRoute, notFound } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';

import { EmailNotFoundPanel } from '../-components/empty-states';
import { ThreadPanel } from '../-components/thread-panel';
import type { Id } from '@minty/shared/ids';
import { DetailsLoading } from '~/components/list-panel-states';
import { useTRPC } from '~/lib/trpc';

export const Route = createFileRoute('/_dashboard/mailbox/sent/$emailId')({
  pendingComponent: DetailsLoading,
  notFoundComponent: EmailNotFoundPanel,
  component: SentEmailRoute,
});

// A sent message is read in its conversation, which is why `sent/` keeps its own
// tree instead of collapsing into `$folder/`.
function SentEmailRoute() {
  const trpc = useTRPC();
  const { emailId } = Route.useParams();
  const navigate = Route.useNavigate();
  const { data: details } = useSuspenseQuery(
    trpc.emails.views.getSentEmail.queryOptions({
      emailId: emailId as Id<'emails'>,
    }),
  );
  const returnToList = () =>
    void navigate({ to: '/mailbox/sent', search: true });

  if (details === null) {
    throw notFound();
  }

  return (
    <ThreadPanel
      key={emailId}
      details={details}
      selectedEmailId={emailId}
      onSelectedEmailMoved={returnToList}
      onThreadMoved={returnToList}
    />
  );
}
